<template>
	<ModalComponent ref="modalRef" :isHeader="false" :isFooter="false">
		<div class="bantuan text-white bg-grey-1 p-6 rounded">
			<div class="text-3.5xl mb-6">Bantuan</div>

			<div class="text-sm font-bold mb-2.5">
				Digital Gold Participant Account No. (RPED)
			</div>
			<div class="text-xs mb-6">
				Digital Gold Participant Account (RPED) is a savings account in the name of the Digital Gold Participant, opened
				through a Physical Gold Trading Broker (in the form of a bank account) and managed directly by the Digital Gold
				Participant. RPED is used to transact in the international physical gold market. Like a digital wallet, you need
				to top up (transfer) funds into your RPED to carry out physical gold buy/sell transactions. You can withdraw
				your transaction profits from RPED to your Withdrawal Account.
			</div>

			<div class="text-sm font-bold mb-2.5">
				Primary Withdrawal Account
			</div>
			<div class="text-xs mb-6">
				Withdrawal Account is an operational funds account in the name of the Digital Gold Participant, managed directly
				by each participant, and obtained together with the opening of an RPED. The Withdrawal Account is a bank account
				used for general operational activities. The bank providing the Withdrawal Account corresponds to the bank you
				selected during RPED KYC registration. The Withdrawal Account serves to hold withdrawal funds from RPED.
			</div>

			<div class="text-sm font-bold mb-2.5">
				Holder Identification Number (HIN)
			</div>
			<div class="text-xs mb-6">
				Holder Identification Number (HIN) is a unique identification number assigned to each Digital Gold Participant,
				indicating ownership of Physical Gold. The HIN is obtained together with the opening of an RPED.
			</div>

			<div class="text-sm font-bold mb-2.5">
				Physical Gold Broker
			</div>
			<div class="text-xs mb-6">
				Physical Gold Broker (or "Broker") is a party that meets the requirements set by the Futures Exchange and has
				obtained approval from the Head of Bappebti to channel buy or sell transactions on behalf of Digital Gold
				Participants to the Digital Physical Gold Market. In physical gold trading, the Broker acts as the registrar for
				prospective Physical Gold Trading Participants, records buy/sell transactions, and facilitates physical gold
				withdrawals.
			</div>

			<div class="text-center">
				<button type="button" class="btn c-btn-theme btn" @click="closeModal()">OK</button>
			</div>
		</div>
	</ModalComponent>
</template>

<script>
import ModalComponent from '../../../components/ModalComponent.vue'

export default {
	name: 'BantuanRegister',
	components: {
		ModalComponent
	},
	data() {
		return {
			modalRef: null
		}
	},
	methods: {
		openModal() {
			this.$refs.modalRef.openModal()
		},
		closeModal() {
			this.$refs.modalRef.closeModal()
		}
	}
}
</script>

<style scoped>
.bantuan {
	width: 45rem;
}

.btn {
	width: 10rem;
}
</style>